import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ErrorMessage(props) {
  return (
    <div
      className="errormessages-wrapper"
      data-test="errormessages-wrapper-row">
      <div className="sync-bar" data-test="errormessages-section">
        <div
          className="requiredwitherr-icon"
          data-test="errormessages-requiredwitherr-icon">
          <FontAwesomeIcon icon={["far", "exclamation-triangle"]} />
        </div>
        <span
          className="requiredwitherr-input"
          data-test="errormessages-requiredwitherr-input">
          {props.messages}
        </span>
      </div>
    </div>
  );
}
